import axios from "axios";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Fieldset } from "primereact/fieldset";
import { Panel } from "primereact/panel";
import classes from "./PlayerPointsModal.module.css";
import { getPlayerPointsApi } from "../http/http";
import { togglePlayerPointsModal } from "../store/slices/playerPointsModalSlice";
import SmallLoader from "./SmallLoader";
import { useTranslation } from "react-i18next";

const PlayerStatsModal = ({ matchFixtureId, playerId, playerPointsModal }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [player, setPlayer] = useState({});
    const [points, setPoints] = useState({});
    const [totalPoints, setTotalPoints] = useState({});
    const [calculations, setCalculations] = useState({});
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const fetchDataFromBackend = async () => {
        try {
            setLoading(true);
            const response = await getPlayerPointsApi(matchFixtureId, playerId, userDetails?.token);

            console.log(response, 'response-----');

            if (response?.data?.status == 0) {
                setError(true);
            } else {
                setError(false);
                setPlayer(response?.data?.player);
                setPoints(response?.data?.points);
                setTotalPoints(response?.data?.totalPoints);
                setCalculations(response?.data?.calculations);
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(
                error?.response?.data?.message ||
                error?.data?.message ||
                error?.message ||
                error
            );
        }
    };

    useEffect(() => {
        if (playerPointsModal || playerId) {
            fetchDataFromBackend();
        }
    }, [playerPointsModal, playerId]);

    return (
        <Dialog
            header={
                t("176")
            }
            visible={playerPointsModal}
            position="bottom"
            // maximizable
            style={{ width: "330px" }}
            onHide={() =>
                dispatch(togglePlayerPointsModal({
                    matchFixtureId: null,
                    playerId: null
                }))
            }
        >
            {loading ? (
                <SmallLoader />
            ) : !error ? (
                <>
                    <div className={classes.container}>
                        <div className={classes.sub_container}>
                            <Panel
                                header={
                                    <div className={classes.panel_header}>
                                        <div className={classes.image_container}>
                                            <img
                                                src={player?.playerPhoto}
                                                alt={player?.playerName}
                                                className={classes.image}
                                            />
                                        </div>
                                        <p className={classes.text}>{player?.playerName}</p>
                                    </div>
                                }
                            >
                                <div className={classes.panel_container}>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("158")}
                                            <br />({calculations?.minutes}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.minutesPoints}
                                        </p>
                                    </div>

                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("159")}
                                            <br />({calculations?.rating}) :{" "}
                                        </p>

                                        <p className={classes.text_right}>{points?.ratingPoints}</p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("160")}

                                            <br />({calculations?.shots}) :
                                        </p>

                                        <p className={classes.text_right}>{points?.shotsPoints}</p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("161")}

                                            <br />({calculations?.goal}) :
                                        </p>
                                        <p className={classes.text_right}>{points?.goalPoints}</p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("162")}

                                            <br />({calculations?.goalsConceded}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.goalsConcededPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("163")}

                                            <br />({calculations?.goalAssists}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.goalAssistsPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("164")}

                                            <br />({calculations?.goalSaves}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.goalSavesPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("165")}

                                            <br />({calculations?.passes}) :
                                        </p>
                                        <p className={classes.text_right}>{points?.passesPoints}</p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("166")}

                                            <br />({calculations?.fouls}) :
                                        </p>
                                        <p className={classes.text_right}>{points?.foulsPoints}</p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("167")}

                                            <br />({calculations?.yellowCard}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.yellowCardPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("168")}

                                            <br />({calculations?.redCard}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.redCardPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("169")}

                                            <br />({calculations?.tackleBlock}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.tackleBlockPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("170")}

                                            <br />({calculations?.tackleInterception}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.tackleInterceptionPoints}
                                        </p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("171")}

                                            <br />({calculations?.duel}) :
                                        </p>
                                        <p className={classes.text_right}>{points?.duelPoints}</p>
                                    </div>
                                    <div className={classes.grid}>
                                        <p className={classes.text}>
                                            {t("172")}

                                            <br />({calculations?.dribble}) :
                                        </p>
                                        <p className={classes.text_right}>
                                            {points?.dribblePoints}
                                        </p>
                                    </div>
                                </div>
                            </Panel>
                        </div>
                        <div className={classes.btn_container}>
                            <Fieldset
                                style={{ width: "200px" }}
                                legend={
                                    t("173")
                                }
                            >
                                <p className={classes.points}>
                                    {t("174")}
                                    {totalPoints?.totalPoints}{" "}
                                </p>
                            </Fieldset>
                        </div>
                    </div>
                </>
            ) : (
                <div className={classes.message_box}>
                    <p className={classes.message}>
                        {t("175")}
                    </p>
                </div>
            )}
        </Dialog>
    );
};

export default PlayerStatsModal;